import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/theme.css"; // ✅ IMPORT HERE

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
